import React from 'react'
import { styled } from '@mui/material/styles'
import { Paper, Box, Typography } from '@mui/material'
import './styles.css'
import { Height } from '@mui/icons-material'
import colors from '@/styles/colors'
import { Topic } from '@/types'
import { useNavigate } from 'react-router-dom'

interface PatternItemCardProps {
  topic: Topic
}

const PatternItemCard = (props: PatternItemCardProps) => {
  const { topic } = props
  const navigate = useNavigate()

  const handleClick = () => {
    // Navigate to preview page for public viewing (read-only)
    navigate(`/preview?topicID=${topic.topicID}&topicType=${topic.topicType}`)
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio: 1,
        borderRadius: 1,
        overflow: 'hidden',
        backgroundImage:
          topic.latestEgo?.photoAlbumURL || topic.profilePicThumbURL
            ? `url(${topic.latestEgo?.photoAlbumURL || topic.profilePicThumbURL})`
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        cursor: 'pointer',
        '&:hover': {
          boxShadow:
            '0 4px 12px rgba(99, 102, 241, 0.5), 0 2px 4px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(99, 102, 241, 0.6)',
          transform: 'translateY(-4px)',
        },
      }}
    />
  )
}

export default PatternItemCard
